// useMarkAllNotificationsRead — общий обработчик «прочитать все» для шапок панели
// и шторки. PowerSync local UPDATE (read_at) — `usePowerSyncQuery` выше по дереву
// реактивно перечитает список после локальной записи (optimistic не нужен).

import { toast } from "@studyhub/ui/toast";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { getPowerSync } from "@/lib/powersync/client";

export function useMarkAllNotificationsRead(): () => Promise<void> {
	const { t } = useTranslation("notifications");
	return useCallback(async () => {
		try {
			await getPowerSync().execute(`UPDATE notifications SET read_at = ? WHERE read_at IS NULL`, [
				new Date().toISOString(),
			]);
			toast.success(t("toast.allRead"));
		} catch {
			toast.error(t("errorTitle"));
		}
	}, [t]);
}
